import { createFileRoute } from "@tanstack/react-router";

import GmpUpload from "~/pages/GmpUpload";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/gmp-upload")({
  staticData: ROUTE_STATIC.gmpUpload,
  component: GmpUpload,
});
